import { render, staticRenderFns } from "./seatsList.vue?vue&type=template&id=e707af46&scoped=true&"
import script from "./seatsList.vue?vue&type=script&lang=js&"
export * from "./seatsList.vue?vue&type=script&lang=js&"
import style0 from "./seatsList.vue?vue&type=style&index=0&id=e707af46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e707af46",
  null
  
)

export default component.exports